import type { Control, FieldPath, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Overline } from '@/components/atoms/Eyebrow';
import { FormTextarea, FormTextField } from '@/components/organisms/FishGroupForms';

import styles from './SiteActionDialog.module.scss';

interface TreatmentFieldsProps<TFieldValues extends FieldValues> {
    control: Control<TFieldValues>;
    methodName: FieldPath<TFieldValues>;
    notesName: FieldPath<TFieldValues>;
}

/** A whole-group delousing: how, free text, and notes; both optional. */
export default function TreatmentFields<TFieldValues extends FieldValues>(
    props: TreatmentFieldsProps<TFieldValues>
) {
    const { control, methodName, notesName } = props;
    const { t } = useTranslation('fishGroups');
    return (
        <section className={styles.section}>
            <Overline as="h3" className={styles.sectionLabel}>
                {t('siteActions.form.treatment')}
            </Overline>
            <FormTextField
                control={control}
                name={methodName}
                label={t('siteActions.form.treatmentMethod')}
                placeholder={t('siteActions.form.treatmentMethodPlaceholder')}
                optional
                rules={{ maxLength: 255 }}
            />
            <FormTextarea
                control={control}
                name={notesName}
                label={t('siteActions.form.notes')}
                placeholder={t('siteActions.form.treatmentNotesPlaceholder')}
                optional
            />
        </section>
    );
}
